import React from 'react'
import './brandAndCommunity.css'
import img from "../../../Asset/demo-community-pic.png"

const community = () => {
    return (
        <div class="community-main py-[4.5rem] md:py-20 pattern-container">

            {/* Community content goes here */}
            <div className="community flex flex-col lg:flex-row justify-center items-center ">
                <div className="heading-community w-full md:w-1/2 p-5 md:p-10 flex flex-col md:flex-row gap-6 md:gap-0 mb-4 md:mb-0">
                    <p class="text-[var(--white)] text-[2.5rem] md:text-[3.5rem] text-left leading-9 md:leading-[1.1] font-ClashGrotesk font-[440]">
                        Hear from our community
                    </p>

                    <p className='font-manrope text-base text-[var(--white)] md:hidden'>We are on a mission to introduce sports in people’s lives and help them re-discover the joy of play to create a life outside the ordinary.</p>
                </div>



                <div className="community-cards flex flex-col w-full px-2  2xl:w-1/2 justify-end mr-2 " >

                    {/* Community Card 1 */}
                    <div class="w-[full]   flex justify-end mr-3 md:mr-8 -mb-3">

                        <div className=" flex  community-comments-parent w-[76%] md:w-[73%] pl-4 md:pl-8 py-3 md:py-6 pr-2 bg-[var(--white)]   justify-center items-center rounded-lg shadow-xl  border border-opacity-10 border-solid border-black z-30">
                            {/* <div className="image-container  w-1/3 ">
                                <img className='w-full' src={img} alt="demo" />
                            </div> */}
                            <div className="community-comments flex flex-col text-left  text-[#616161] font-ClashGrotesk pl-2">
                                <h1 class="text-[0.73rem] md:text-xl font-semibold">Jhanvi Dubey</h1>
                                {/* <h2 class="text-[0.51rem] md:text-sm">Budding footballer</h2> */}
                                <p class="text-[0.51rem] md:text-sm mt-2 font-manrope text-left w-full    ">Came for the sport, stayed for the vibes. Net Gala strikes that rare balance—high energy, healthy competition, and a community that just gets it.</p>
                            </div>
                        </div>
                    </div>


                    {/* Community Card 2 */}
                    <div class="w-[full]  flex justify-start md:ml-6 ml-3 ">

                        <div className="flex community-comments-parent w-[76%] md:w-[73%] pl-4 md:pl-8 py-3 md:py-6 pr-2 bg-[var(--white)] justify-center items-center rounded-lg shadow-xl border border-opacity-10 border-solid border-black">

                            <div className="community-comments flex flex-col text-left font-ClashGrotesk text-[#616161] pl-2">
                                <h1 class="text-[0.73rem] md:text-xl font-semibold">Tarini Sundar</h1>
                                {/* <h2 class="text-[0.51rem] md:text-sm">Budding footballer</h2> */}
                                <p class="text-[0.51rem] md:text-sm mt-2 font-manrope text-left w-full">Net Gala was a game changer when I moved back from the US. I reconnected with people through racket sports and built great connections outside of play too!
                                </p>
                            </div>
                        </div>
                    </div>


                    {/* Community Card 3 */}
                    <div class="w-[full]   flex justify-end md:mr-8 z-30 -mt-2 mr-3">

                        <div className="flex community-comments-parent w-[76%] md:w-[73%] pl-4 md:pl-8 py-3 md:py-6 pr-2 bg-[var(--white)] justify-center items-center rounded-lg shadow-xl border border-opacity-10 border-solid border-black">

                            <div className="community-comments flex flex-col text-left font-ClashGrotesk text-[#616161] pl-2">
                                <h1 class="text-[0.73rem] md:text-xl font-semibold">Karan Singh </h1>
                                {/* <h2 class="text-[0.51rem] md:text-sm">Ultimate Frisbee Fanatic</h2> */}
                                <p class="text-[0.51rem] md:text-sm mt-2 font-manrope text-left w-full">An amazing mix of competitive spirit and casual fun — Net Gala's weekend games are my favourite way to connect with others who love to play.</p>
                            </div>
                        </div>
                    </div>


                </div>
            </div>

        </div>
    )
}

export default community
